import { useState } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Expandable = ({ children, title, subTitle, count, reorder }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = (e) => {
        if (e.target.closest('.reorder-container'))
            return;
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={"expandable-container" + (isExpanded ? " expanded" : "")}>
            <div className="expandable-title" onClick={toggleExpand}>
                <div className="flex f-col f-start" style={{ flexGrow: 0 }}>
                    <div className="expandable-title-text">{title}</div>
                    {!!subTitle && <div className="expandable-subtitle">{subTitle}</div>}
                </div>
                {!!reorder && false && (
                    <div className="ml-auto reorder-container">
                        {reorder}
                    </div>
                )}
                {!!count && (
                    <div className="ml-auto expandable-count">
                        ({count})
                    </div>
                )}
                <div className="expandable-toggle">
                    <FontAwesomeIcon icon={faChevronDown} color="#828282" />
                </div>
            </div>
            
            <div className="expandable-content">
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Expandable;